import React, { useContext, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';

const CalltoActionSection = () => {
  const form = useRef();

  const { is750, is1100 } = useContext(ResponsiveContext);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_KEY
      )
      .then(
        () => {
          window.location.reload();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <>
      <div className='d-flex row align-content-center justify-content-center'>
        <h6
          className={`${
            is1100 ? 'fs-2' : 'fs-4'
          } fw-bold text-muted fst-italic`}
          style={{
            boxShadow:
              'rgba(255, 120, 3, 0.4) 0px 5px, rgba(255, 120, 3, 0.3) 0px 10px, rgba(255, 120, 3, 0.2) 0px 15px, rgba(255, 120, 3, 0.1) 0px 20px, rgba(255, 120, 3, 0.05) 0px 25px',
            width: '80%',
            marginTop: '50px',
            marginBottom: '50px',
          }}
        >
          ¿PODEMOS AYUDARTE?
        </h6>
      </div>
      <div className='subscribe-section bg-with-black'>
        <div className='container'>
          <div className='row'>
            <div className='col-xs-12'>
              <div className='subscribe-head'>
                {is750 ? (
                  <form
                    ref={form}
                    onSubmit={sendEmail}
                    className='d-flex flex-column'
                  >
                    <div className='d-flex justify-content-between'>
                      <div className='col-4'>
                        <label
                          htmlFor='exampleInputText'
                          className='form-label text-white mt-3 fs-4 text-start'
                          style={{ width: '100%' }}
                        >
                          Nombre:
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='user_name'
                        />
                        <label
                          htmlFor='exampleInputEmail1'
                          className='form-label text-white mt-3 fs-4 text-start'
                          style={{ width: '100%' }}
                        >
                          Email:
                        </label>
                        <input
                          type='email'
                          className='form-control'
                          id='exampleInputEmail1'
                          name='user_email'
                        />
                      </div>
                      <div
                        className='col-6'
                        // style={{ height: '100%' }}
                      >
                        <label
                          htmlFor='exampleInputText'
                          className='form-label text-white mt-3 fs-4 text-start'
                          style={{ width: '100%' }}
                        >
                          Mensaje:
                        </label>
                        <textarea
                          className='form-control d-flex align-items-center'
                          placeholder='Escribe aquí tu mensaje...'
                          id='floatingTextarea'
                          name='message'
                          style={{ width: '100%', height: '130px' }}
                        />
                        <input
                          type='submit'
                          className='btn btn-primary mt-3 fs-5'
                          value='Enviar'
                          style={{ width: '150px', height: '40px' }}
                        />
                      </div>
                    </div>
                  </form>
                ) : (
                  <form ref={form} onSubmit={sendEmail}>
                    <label
                      htmlFor='exampleInputText'
                      className='form-label text-white mt-3 fs-4 text-start'
                      style={{ width: '100%' }}
                    >
                      Nombre:
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      name='user_name'
                    />
                    <label
                      htmlFor='exampleInputEmail1'
                      className='form-label text-white mt-3 fs-4 text-start'
                      style={{ width: '100%' }}
                    >
                      Email:
                    </label>
                    <input
                      type='email'
                      className='form-control'
                      id='exampleInputEmail1'
                      name='user_email'
                    />
                    <label
                      htmlFor='exampleInputText'
                      className='form-label text-white mt-3 fs-4 text-start'
                      style={{ width: '100%' }}
                    >
                      Mensaje:
                    </label>
                    <textarea
                      className='form-control'
                      placeholder='Escribe aquí tu mensaje...'
                      id='floatingTextarea'
                      name='message'
                      style={{ height: '100px' }}
                    />
                    <input
                      type='submit'
                      className='btn btn-primary mt-5 fs-5'
                      value='Enviar'
                      style={{ width: '100%', height: '40px' }}
                    />
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalltoActionSection;
